export function capitalize(value: string) {
  if (!value || typeof value !== "string") return "";

  return value
    .split(" ")
    .map((word) =>
      word
        .split("-")
        .map((sub) =>
          sub ? sub.charAt(0).toUpperCase() + sub.slice(1).toLowerCase() : ""
        )
        .join("-")
    )
    .join(" ")
    .trim();
}

export function firstChar(value: string) {
  if (!value || typeof value !== "string") return "";
  return value.charAt(0).toUpperCase();
}

export function removeQuotes(input: string) {
  if (!input || typeof input !== "string") return "";
  return input.replace(/"/g, "");
}

export function sliceString(str: string = "", size: number, dot?: string) {
  const splitStr = str?.split(".");
  splitStr.pop();
  const newStr = splitStr?.join();

  return newStr?.length > size
    ? `${newStr?.slice(0, size)}${dot || ""}`
    : newStr;
}
